import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-report-icon',
    templateUrl: './report-icon.component.html',
    styleUrls: ['./report-icon.component.scss']
})
export class ReportIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
